/**
 * Runtime environment configuration utility
 * Reads from window.__ENV__ (injected at container startup from ConfigMap)
 * Falls back to import.meta.env (build-time values from .env file)
 */
export const getEnv = (key: string): string | undefined => {
  const runtimeEnv = (window as any).__ENV__;
  return runtimeEnv?.[key] || import.meta.env[key];
};
